import React from 'react';
import { Table } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import TableActions from 'components/TableActions';
// @ts-ignore
import WorkTypeEntityTypeName from 'components/WorkTypeEntityTypeName';
// @ts-ignore
import WorkTypeName from 'components/WorkTypeName';
// @ts-ignore
import WorkTypeIsPieceRate from 'components/WorkTypeIsPieceRate';
// @ts-ignore
import WorkTypePayrollCode from 'components/WorkTypePayrollCode';
import RoleButtonLink from 'components/RoleButtonLink';
import { ADMIN } from 'components/RoleGate/constants';

interface Props {
    workTypeId?: number;
}

export default class WorkTypesTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { workTypeId } = this.props;
        if (!workTypeId) {
            return null;
        }
        return (
            <Table.Row>
                <Table.Cell>
                    <WorkTypeName workTypeId={workTypeId} />
                </Table.Cell>
                <Table.Cell>
                    <WorkTypeEntityTypeName workTypeId={workTypeId} />
                </Table.Cell>
                <Table.Cell>
                    <WorkTypeIsPieceRate
                        workTypeId={workTypeId}
                        truthyValue="Piece Rate"
                        falsyValue="Hourly"
                    />
                </Table.Cell>
                <Table.Cell>
                    <WorkTypePayrollCode workTypeId={workTypeId} />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <RoleButtonLink
                            requiredRoles={[ADMIN]}
                            params={{
                                selectedWorkType: workTypeId,
                                workTypeDeleteModal: true
                            }}
                        >
                            Delete
                        </RoleButtonLink>
                    </TableActions>
                </Table.Cell>
            </Table.Row>
        );
    }
}
